import React from 'react';

const Education = () => {
  return (
    <section id="work-experience">
      <h2>Education</h2>
      <p>
        <strong>Masters in Computer Science</strong> -  UTA - Jan 2023 - Dec 2024
      </p>
      <p>
        <strong>MTech Integrated Software Engineering</strong> - VIT - Jul 2015 - Jun 2020
      </p>
    </section>
  );
};

export default Education;



